module.exports = __webpack_public_path__ + "krebs-cycle.0c8ffe3bdc6723a35d58b9d6f846a663.png";